module.exports = __webpack_public_path__ + "media/images/pages/enrichment/featured-banner-4d9b53d0e0a60e77345a51db7b8e76ec.svg";